import React, { Fragment, useRef, useState } from "react";
import { Helmet } from "react-helmet";

import ChangeTempPassword from "./ChangeTempPassword";
//store
import { useStore } from "src/store/Store";
import { updateUser } from "src/store/userReducer";
import OtpInput from "react-otp-input";

import mobiscroll, { snackbar, toast } from "@mobiscroll/react";
import { Checkbox } from "@mobiscroll/react5";
import { Modal } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { getMyProfile, verifyTurnstileToken } from "src/components/Dashboard/Profile/api";
import Loader from "src/components/Dashboard/common/Loader";
import line from "../../assets/Lines.svg";
import grid from "../../assets/grid.svg";
import login_icon from "../../assets/login icon  human.svg";
import doctor from "../../assets/login-doctor.svg";
import signin_circle from "../../assets/signin-circle.svg";
import "../ApolloConnection/UnauthorizedConnection/ApolloProviderSignup";
import "../Dashboard/Layouts/Card.css";

import "./Auth.scss";
import OtpVerification from "./OtpVerification";
import SetMFAasTOTP from "./SetMFAasTOTP";
import PDFViewer from "src/components/Dashboard/Layouts/PDFViewer";
import { signIn, signOut, fetchMFAPreference, getCurrentUser, fetchAuthSession, fetchUserAttributes } from "@aws-amplify/auth";
import { useDispatch } from "react-redux";
import { removeUser, storeUser } from "src/features/user/userSlice";
import { fetchDiagnosisLabTests, fetchDiagnosisNotes, fetchDiagnosisTemplates, fetchPrescriptionTemplates } from "src/features/templates/templatesActions";
import { fetchPatients } from "src/features/patients/patientsActions";
import { fetchTimeSlots } from "src/features/timeslots/timeslotsActions";
import { sendVerificationCodeService, verifyOtpAndFinalizeService } from "./VerifyEmailUtility";
import { resetIdleTimer } from "src/components/ApolloConnection/ApolloProviderComponent";


const env = process.env.REACT_APP_ENVIRONMENT;
const tnc_file = process.env.REACT_APP_TNC;
const SITE_KEY = process.env.REACT_APP_TURNSTILE_KEY;
const IS_PROD = env === 'PRODUCTION';

function SignIn() {

  const dispatch = useDispatch();
  const history = useHistory();
  const [user, setUser] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [authenticating, setAuthenticating] = useState(false);
  const [congnitoUser, setCognitoUser] = useState(null);
  const [authType, setAuthType] = useState(null);
  const [errorLogin, setErrorLogin] = useState("");
  const [loader, setLoader] = useState(false);
  const [changeTempPassword, setChangeTempPassword] = useState(null);
  const [checked, setChecked] = useState(false);
  const [url, setUrl] = useState(process.env.REACT_APP_CLINIC_URL);
  const [showTNC, setShowTNC] = useState(false);
  const [userData, setUserData] = useState(null);
  const [mfa, setMfa] = useState(null);
  const [showPDF, setShowPDF] = useState(false);

  const isLoggingInRef = useRef(false);


  // NEW STATES for OTP flow
  const [needsEmailVerification, setNeedsEmailVerification] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpErrorMessage, setOtpErrorMessage] = useState("");
  const [resendDisabled, setResendDisabled] = useState(false);
  const [resendTimer, setResendTimer] = useState(0);

  //captcha token state
  const turnstileRef = useRef(null);
  const [verifyingCaptcha, setVerifyingCaptcha] = useState(false);
  const [captchaError, setCaptchaError] = useState(null);

  // New state variables for invisible captcha execution tracking
  const [isCaptchaExecuting, setIsCaptchaExecuting] = useState(false);
  const [isWidgetReady, setIsWidgetReady] = useState(false);
  const captchaExecutionPromiseRef = useRef(null);

  const { globalStateUser, dispatchUser } = useStore();

  const checkMFA = async () => {
    const user = await getCurrentUser();
    setUserData(user);
    const mfa = await fetchMFAPreference();
    return mfa;
  };
  // sdfsdf
  const minMaxLength = (text, minLength, maxLength) => {
    let result = !text || text.length < minLength;
    if (maxLength) result = result || text.length < minLength;
    return result;
  };

  const validEmail = (text) => {
    const regex = new RegExp(
      /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
    );

    return !regex.test(text);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let currentFormErrors = {};

    switch (name) {
      case "username":
        setUser({ ...user, username: value });
        if (!value || validEmail(value)) {
          currentFormErrors[name] = `Email address is invalid`;
        } else {
          delete currentFormErrors[name];
          localStorage.setItem("username", value);
        }
        break;
      case "password":
        setUser({ ...user, password: value });
        if (minMaxLength(value, 8)) {
          currentFormErrors[name] = `Password should have minimum 8 characters`;
        } else {
          delete currentFormErrors[name];
        }
        break;
      default:
        break;
    }
    setFormErrors(currentFormErrors);
  };

  const forgotPassword = () => {
    history.push("/forgot-password");
  };

  //mock functions for local/staging development
  let verifyTurnstileOnServer = async (token) => ({ success: true });
  let executeCaptcha = () => Promise.resolve('dummy-token-local');

  // Production captcha functions
  if (IS_PROD) {
    // call backend to verify turnstile token
    verifyTurnstileOnServer = async function verifyTurnstileOnServer(token) {
      if (!token) return { success: false, error: 'missing-token', message: 'Security verification token is missing. Please try logging in again.' };

      try {
        setVerifyingCaptcha(true);
        setCaptchaError(null);

        const response = await verifyTurnstileToken({ token: token });

        setVerifyingCaptcha(false);

        // Handle undefined response (API error)
        if (!response) {
          return {
            success: false,
            error: 'network',
            message: 'Unable to complete security verification. Please check your internet connection and try again. If the problem persists, please refresh the page.'
          };
        }

        // Check if response has success field
        if (response.success === true) {
          return { success: true, data: response };
        } else {
          // Extract error details from response
          const errorCode = response.error?.code || 'unknown';

          // Provide user-friendly messages based on error type
          let userMessage = 'Security verification failed. Please try logging in again.';

          if (errorCode === 'invalid-input-response' || errorCode === 'timeout-or-duplicate') {
            userMessage = 'Security verification expired. Please try logging in again.';
          } else if (errorCode === 'internal-error') {
            userMessage = 'Security verification encountered an error. Please refresh the page and try again.';
          } else if (errorCode === 'network') {
            userMessage = 'Unable to complete security verification. Please check your internet connection and try again. If the problem persists, please refresh the page.';
          }

          return {
            success: false,
            error: errorCode,
            message: userMessage
          };
        }
      } catch (err) {
        setVerifyingCaptcha(false);
        console.error('Security verification error:', err);
        return {
          success: false,
          error: 'network',
          message: 'Unable to complete security verification. Please check your internet connection and try again. If the problem persists, please refresh the page.'
        };
      }
    }

    // Execute invisible Turnstile captcha and get fresh token
    // This uses a ref to store the promise resolve/reject so the render callback can use it
    executeCaptcha = function executeCaptcha() {
      return new Promise((resolve, reject) => {
        // Check if widget is ready
        if (!isWidgetReady || !window.turnstile || !turnstileRef.current) {
          reject({ error: 'widget-not-ready', message: 'Security check is still loading. Please wait a moment and try again. If this persists, please refresh the page.' });
          return;
        }

        // Check if already executing
        if (isCaptchaExecuting) {
          console.warn('Captcha already executing - resetting and retrying');
          // Fallback safety reset
          if (window.turnstile && turnstileRef.current) {
            window.turnstile.reset(turnstileRef.current);
          }
          setIsCaptchaExecuting(false);
          // not rejecting now - allow it to proceed after reset
        }

        setIsCaptchaExecuting(true);
        setCaptchaError(null);

        // Store promise callbacks in ref so render callback can access them
        captchaExecutionPromiseRef.current = { resolve, reject };

        // Set timeout for execution
        const timeoutId = setTimeout(() => {
          if (captchaExecutionPromiseRef.current) {
            setIsCaptchaExecuting(false);
            captchaExecutionPromiseRef.current.reject({
              error: 'timeout',
              message: 'Security verification timed out. Please try logging in again. If this continues, please refresh the page.'
            });
            captchaExecutionPromiseRef.current = null;
          }
        }, 10000); // 10 second timeout

        // Store timeout ID to clear it if callback fires
        if (captchaExecutionPromiseRef.current) {
          captchaExecutionPromiseRef.current.timeoutId = timeoutId;
        }

        // Execute the invisible captcha
        // The callback set during render() will handle the token
        try {
          window.turnstile.execute(turnstileRef.current);
        } catch (err) {
          clearTimeout(timeoutId);
          setIsCaptchaExecuting(false);
          captchaExecutionPromiseRef.current = null;
          reject({ error: 'execution-error', message: 'Security verification failed to start. Please try logging in again. If this continues, please refresh the page.' });
        }
      });
    };
  }

  const login = async () => {
    // Validate form fields
    if (user.username == null || user.password == null) {
      setFormErrors({
        username: user.username ? undefined : "This field is required",
        password: user.password ? undefined : "This field is required",
      });
      return;
    }

    let captchaPassed = true;

    if (IS_PROD) {
      // Check if widget is ready
      if (!isWidgetReady) {
        setCaptchaError("Security check is still loading. Please wait a moment and try again. If this persists, please refresh the page.");
        return;
      }

      // // Prevent double-clicking
      if (isCaptchaExecuting || verifyingCaptcha || authenticating) {
        return;
      }

      try {
        // Step 0: SAFETY CHECK - Reset widget to clear any stuck state
        if (window.turnstile && turnstileRef.current) {
          window.turnstile.reset(turnstileRef.current);
        }

        // Also reset execution state flags
        setIsCaptchaExecuting(false);

        // Step 1: Execute invisible security check to get fresh token
        setCaptchaError(null);
        const token = await executeCaptcha();

        // Step 2: Immediately verify token with backend (don't cache it)
        const verification = await verifyTurnstileOnServer(token);

        if (!verification || !verification.success) {
          // Show user-friendly error with clear guidance
          setCaptchaError(verification?.message || "Security verification failed. Please try logging in again. If this continues, please refresh the page.");
          captchaPassed = false;

          // Reset widget for next attempt
          if (window.turnstile && turnstileRef.current) {
            window.turnstile.reset(turnstileRef.current);
          }

        }

      } catch (error) {
        // Handle security check execution errors with clear guidance
        const errorMessage = error.message || "Security verification encountered an error. Please try logging in again. If this continues, please refresh the page.";
        setCaptchaError(errorMessage);
        captchaPassed = false;

        // Reset widget and state if possible
        if (window.turnstile && turnstileRef.current) {
          window.turnstile.reset(turnstileRef.current);
        }
        setIsCaptchaExecuting(false);
      }
    }



    // Only proceed with sign-in if captcha logic passed (or if IS_PROD is false)
    if (!captchaPassed) {
      return;
    }

    toast({ message: "Authenticating", color: "success" });
    setAuthenticating(true);
    setErrorLogin("");

    // Proceed with sign-in
    _signIn(user.username, user.password);
  };

  const checkEmailVerificationAndLogin = async () => {
    try {
      const attributes = await fetchUserAttributes();

      // Check if email is verified
      if (attributes.email_verified === 'false' || !attributes.email_verified) {
        setOtp("");
        setOtpErrorMessage("");
        setNeedsEmailVerification(true);

        handleSendCode();

      } else {
        await onLogin();
      }

    } catch (error) {
      console.error("Error checking email verification:", error);
      await onLogin();

    } finally {
      setLoader(false);
    }
  };

  const handleSendCode = () => {
    // Pass local states and global dependencies to the service function
    sendVerificationCodeService({
      setLoader,
      setResendDisabled,
      setResendTimer,
      snackbar
    });
  };

  const handleVerifyOtp = async () => {
    if (!otp || otp.length !== 6) {
      setOtpErrorMessage("Please enter a valid 6-digit code");
      return;
    }

    // Pass local states and global dependencies to the service function
    await verifyOtpAndFinalizeService({
      otp,
      setLoader,
      setOtpErrorMessage,
      setNeedsEmailVerification,
      onLogin,
      snackbar
    });
  };

  async function _signIn(username, password) {
    isLoggingInRef.current = true;
    resetIdleTimer();
    setLoader(true);
    try {

      const { isSignedIn, nextStep } = await signIn({ username, password });

      if (nextStep.signInStep == "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED") {
        // history.push("/change-password");
        setChangeTempPassword(user);
      } else if (
        nextStep.signInStep === "CONFIRM_SIGN_IN_WITH_SMS_CODE" ||
        nextStep.signInStep === "CONFIRM_SIGN_IN_WITH_TOTP_CODE" ||
        nextStep.signInStep === "CONTINUE_SIGN_IN_WITH_MFA_SELECTION"
      ) {
        if (
          nextStep.signInStep === "CONTINUE_SIGN_IN_WITH_MFA_SELECTION" ||
          nextStep.signInStep === "CONFIRM_SIGN_IN_WITH_TOTP_CODE"
        )
          setAuthType("TOTP");
        else setAuthType("SMS");
        setCognitoUser(user);
        // history.push("/otp-verification");
      } else {
        if (env !== "dev") {
          let mfa = await checkMFA();

          if (mfa === "NOMFA") {
            setMfa(true);
          } else {
            await checkEmailVerificationAndLogin();
          }
        } else {
          await checkEmailVerificationAndLogin();
        }
      }
    } catch (error) {
      console.error(error);
      setAuthenticating(false);
      snackbar({ message: error.message, color: "danger", });
    }
    setLoader(false);
  }

  async function onLogin() {
    setLoader(true);

    try {
      const userInfo = await getMyProfile();
      let roles = userInfo.roles;
      if (roles.filter((role) => role == "Doctor").length > 0) {

        dispatchUser(
          updateUser({
            userId: userInfo.identityId,
            userMobile: userInfo.phoneNumber,
            userEmail: userInfo.email,
            loginStatus: true,
            userRoles: roles,
            data: userInfo,
          })
        );

        sessionStorage.setItem("userRole", roles);
        sessionStorage.setItem("clinic_id", userInfo.clinicId);
        sessionStorage.setItem("doctorVerified", userInfo.doctorVerified);
        sessionStorage.setItem("role-id", userInfo.id);
        sessionStorage.setItem("loginStatus", true);
        sessionStorage.setItem("showPrompt", true);
        // localStorage.setItem('tncAccepted', 'true');

        await Promise.all([
          dispatch(storeUser(userInfo)),
          dispatch(fetchPatients('', true)),
          dispatch(fetchTimeSlots(true)),
          dispatch(fetchPrescriptionTemplates()),
          dispatch(fetchDiagnosisTemplates()),
          dispatch(fetchDiagnosisNotes()),
          dispatch(fetchDiagnosisLabTests()),
        ])

      } else {
        alert("You have entered credentials with wrong access.");
      }
    } catch (error) {
      snackbar({ message: "Some error occurred while trying to login", color: "danger", });
      console.error("Error: ", error);
    }
    setLoader(false);
  }

  // to clear any existing session - before signing in
  React.useEffect(() => {
    const clearExistingSession = async () => {
      try {
        // Don't clear if user is in the process of logging in
        if (isLoggingInRef.current) {
          console.info("Login in progress, skipping session clear");
          return;
        }

        const session = await fetchAuthSession({ forceRefresh: false }).catch(() => null);
        if (session) {
          await signOut(); // Clear any existing session
          dispatch(removeUser());
          console.info("Existing session cleared.");
        }
        sessionStorage.clear();
        localStorage.removeItem("_expiredTime");
      } catch (error) {
        console.error("Error clearing session:", error);
      }
    };

    clearExistingSession();
  }, []);

  // // React.useEffect(() => {
  // //   const tncAccepted = localStorage.getItem('tncAccepted');
  // //   if (tncAccepted === 'true') {
  // //     setChecked(true);
  // //   } else {
  // //     setChecked(false);
  // //   }
  // // }, [])

  //countdown effect for resend OTP button
  React.useEffect(() => {
    if (resendTimer <= 0) {
      setResendDisabled(false);
      return;
    }

    const timer = setTimeout(() => {
      setResendTimer(t => t - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [resendTimer]);


  // Effect to render the Turnstile widget in invisible mode
  React.useEffect(() => {
    if (IS_PROD) {
      let isMounted = true;
      let retryCount = 0;
      const maxRetries = 10;
      const retryInterval = 500; // 500ms between retries

      const initializeTurnstile = () => {
        // Check if Turnstile script is loaded
        if (window.turnstile && turnstileRef.current) {
          try {
            // Render invisible Turnstile widget
            window.turnstile.render(turnstileRef.current, {
              sitekey: SITE_KEY,
              size: 'invisible', // CRITICAL: Set to invisible mode
              callback: function (token) {
                // This callback fires when execute() is called and token is received
                if (isMounted) {
                  setCaptchaError(null);

                  // If there's a pending promise from executeCaptcha(), resolve it
                  if (captchaExecutionPromiseRef.current) {
                    const { resolve, timeoutId } = captchaExecutionPromiseRef.current;
                    if (timeoutId) clearTimeout(timeoutId);
                    setIsCaptchaExecuting(false);
                    resolve(token);
                    captchaExecutionPromiseRef.current = null;
                  }
                }
              },
              'expired-callback': function () {
                // Handle token expiration
                if (isMounted) {
                  // If there's a pending promise, reject it
                  if (captchaExecutionPromiseRef.current) {
                    const { reject, timeoutId } = captchaExecutionPromiseRef.current;
                    if (timeoutId) clearTimeout(timeoutId);
                    setIsCaptchaExecuting(false);
                    reject({ error: 'expired', message: 'Security verification expired. Please try logging in again.' });
                    captchaExecutionPromiseRef.current = null;
                  } else {
                    setCaptchaError("Security verification expired. Please try logging in again.");
                  }
                }
              },
              'error-callback': function () {
                // Handle widget errors
                if (isMounted) {
                  // If there's a pending promise, reject it
                  if (captchaExecutionPromiseRef.current) {
                    const { reject, timeoutId } = captchaExecutionPromiseRef.current;
                    if (timeoutId) clearTimeout(timeoutId);
                    setIsCaptchaExecuting(false);
                    reject({ error: 'captcha-error', message: 'Security verification encountered an error. Please try logging in again. If this continues, please refresh the page.' });
                    captchaExecutionPromiseRef.current = null;
                  } else {
                    setCaptchaError("Security verification encountered an error. Please try logging in again. If this continues, please refresh the page.");
                  }
                }
              }
            });

            // Mark widget as ready
            if (isMounted) {
              setIsWidgetReady(true);
              setCaptchaError(null);
            }
          } catch (err) {
            console.error('Error initializing Turnstile:', err);
            if (isMounted && retryCount < maxRetries) {
              retryCount++;
              setTimeout(initializeTurnstile, retryInterval);
            } else if (isMounted) {
              setCaptchaError("Security check failed to load. Please refresh the page and try again.");
            }
          }
        } else {
          // Retry if script not loaded yet
          if (retryCount < maxRetries) {
            retryCount++;
            setTimeout(initializeTurnstile, retryInterval);
          } else if (isMounted) {
            setCaptchaError("Security check failed to load. Please refresh the page and try again.");
          }
        }
      };

      // Start initialization
      initializeTurnstile();

      // Cleanup function
      return () => {
        isMounted = false;
        if (window.turnstile && turnstileRef.current) {
          try {
            window.turnstile.remove(turnstileRef.current);
          } catch (err) {
            console.error('Error removing Turnstile widget:', err);
          }
        }
        setIsWidgetReady(false);
      };

    }
  }, [IS_PROD]);

  React.useEffect(() => {
    if (globalStateUser.loginStatus) {
      history.push("/dashboard?prompt=true");
    }
  }, [globalStateUser]);

  if (mfa) {
    return (
      <>
        <SetMFAasTOTP userData={userData} onSuccess={onLogin} />
      </>
    );
  }

  if (congnitoUser) {
    return (
      <>
        <Loader show={loader} />
        <OtpVerification
          cognitoObject={congnitoUser}
          onSuccess={onLogin}
          mfaType={authType}
        />
      </>
    );
  }

  if (changeTempPassword) {
    return <ChangeTempPassword onSuccess={() => setChangeTempPassword(null)} />;
  }


  const handleOtpChange = (e) => {
    const value = e;
    setOtp(value);

    setOtpErrorMessage((value.length != 6) ? "OTP must be 6 digits" : "");
  };


  return (
    <Fragment>
      <Loader show={loader} />
      <PDFViewer
        link={tnc_file}
        show={showPDF}
        setShow={setShowPDF}
        fileName="Terms and Conditions for Clinic"
        customButton={
          <>
            <button
              onClick={() => {
                setShowPDF(false);
                setChecked(true);
              }}
              className="docg-save-btn"
            >
              Accept
            </button>
          </>
        }
      />
      <Helmet>
        <title>Login | Doctor</title>
      </Helmet>
      <Modal
        onHide={() => setShowTNC(false)}
        size="lg"
        show={showTNC}
        // onHide={handleNotificationsView}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg" className="ml-3">
            <span className="ModalTitle">Updated Terms and Conditions</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "82vh", overflow: "auto" }}>
          <iframe
            title="pdf"
            src={tnc_file}
            style={{ width: "600px", height: "500px" }}
            frameborder="0"
          ></iframe>
        </Modal.Body>
      </Modal>

      <div className="mbsc-grid">
        <div className="mbsc-card main-card-wrapper">
          <div className="signup-wrapper">
            <div className="mbsc-row">
              <div className="mbsc-col-xl-5 doctor-images-left mbsc-col-12 p-0">
                <div className="left-signup-div"></div>
                <img src={doctor} className="left-signup-img" />
              </div>

              <div className="mbsc-col-xl-7 mbsc-col-12 signup-right">
                <img src={grid} className="grid-top" />
                <img src={signin_circle} className="signin-circle" />
                <div className="bottom-circle" />
                <div className="top-circle" />

                <div className="right-signup-div">
                  <div className="get-started-wrapper">
                    <p className="get-txt">Welcome to Doctor Portal!</p>

                    {needsEmailVerification ? (
                      <>
                        <p style={{ color: "#757575" }} className="signup-link mt-4">
                          Please enter the verification code sent to your email:
                        </p>
                        <br />
                        <div className="signup-wrapper-inner">
                          <br />
                          <OtpInput
                            value={otp}
                            onChange={handleOtpChange}
                            numInputs={6}
                            hasErrored={otpErrorMessage}
                            errorStyle={"otp-input-error"}
                            separator={<span>&emsp;</span>}
                            containerStyle={"otp-container"}
                            inputStyle={"form-input-otp"}
                            isInputNum={true}
                          />
                          <br />
                          {otpErrorMessage ? (<span className="otp-error">{otpErrorMessage}</span>) : ("")}

                          <button
                            className="pink-button mt-4"
                            onClick={handleVerifyOtp}
                            disabled={loader || !otp || otp.length !== 6}
                          >
                            Verify Email
                          </button>
                          <br />
                          <button
                            className="docg-save-btn mt-2 mx-auto px-5 py-2"
                            onClick={handleSendCode}
                            disabled={resendDisabled || loader}
                            style={{ backgroundColor: '#6c5b7b' }}
                          >
                            {resendDisabled
                              ? `Resend code in ${resendTimer}s`
                              : "Resend verification code"}
                          </button>
                        </div>
                      </>
                    ) : (
                      <>
                        <p style={{ color: "#757575" }} className="signup-link mt-4">
                          To login, please enter your email and password
                        </p>
                        <br />
                        <div className="signup-wrapper-inner">
                          <mobiscroll.Input
                            inputStyle="underline"
                            labelStyle="floating"
                            placeholder=""
                            name="username"
                            type="email"
                            onChange={handleChange}
                            valid={!formErrors.username}
                            errorMessage={formErrors.username}
                            disabled={authenticating}
                          >
                            Enter Email Address*
                          </mobiscroll.Input>
                          <br />
                          <mobiscroll.Input
                            inputStyle="underline"
                            labelStyle="floating"
                            passwordToggle={true}
                            type="password"
                            name="password"
                            onChange={handleChange}
                            valid={!formErrors.password}
                            errorMessage={formErrors.password}
                            // disabled={authenticating}
                            className="input-style"
                            style={{ marginBottom: "10px" }}
                          >
                            Password*
                          </mobiscroll.Input>
                          <br />

                          {/* Turnstile captcha */}
                          {IS_PROD && (
                            <div style={{ margin: '16px 0' }}>
                              <div ref={turnstileRef}></div>
                              {
                                captchaError && (
                                  <div style={{
                                    color: 'red',
                                    marginTop: 6,
                                    fontSize: '14px',
                                    fontWeight: '500'
                                  }}>
                                    {captchaError}
                                  </div>
                                )
                              }
                              {
                                (isCaptchaExecuting || verifyingCaptcha) && (
                                  <div style={{
                                    color: '#c06c84',
                                    marginTop: 6,
                                    fontSize: '14px',
                                    fontStyle: 'italic'
                                  }}>
                                    Verifying security...
                                  </div>
                                )
                              }
                            </div >
                          )}


                          <button className="transparent-button" onClick={forgotPassword}>
                            Forgot Password?
                          </button>
                          <br />
                          <div className="d-flex w-full align-items-center justify-content-center">
                            <div className="custom-repeat-checkbox-cont mr-n4">
                              <Checkbox
                                value="tnc"
                                checked={checked}
                                onChange={(e) => {
                                  setChecked((prev) => !prev);
                                  setShowPDF(true);
                                }}
                              ></Checkbox>
                            </div>
                            <span
                              style={{
                                fontSize: "16px",
                                fontWeight: "600",
                                color: "#6c5b7b",
                                fontFamily: "Poppins",
                              }}
                            >
                              Terms and conditions
                            </span>
                          </div>
                          <button
                            className="pink-button"
                            onClick={login}
                            disabled={
                              authenticating ||
                              !checked ||
                              IS_PROD && (isCaptchaExecuting || verifyingCaptcha || !isWidgetReady)
                            }
                          >
                            <img src={login_icon} />
                            &nbsp;&nbsp; Login
                          </button>
                          <br />

                          <p className="text-danger text-center">{errorLogin}</p>
                          <center>
                            <p className="signup-link">
                              Signin as a:
                              <span>
                                <button
                                  className="transparent-button"
                                  id="signup-btn-small"
                                  onClick={() => {
                                    window.open(url, "_blank");
                                  }}
                                >
                                  Clinic
                                </button>
                              </span>
                            </p>
                          </center>
                        </div >
                      </>
                    )}
                  </div >
                </div >


                <img
                  src={line}
                  className="lines-bottom"
                  style={{ marginLeft: "8%" }}
                />
              </div >
            </div >
          </div >
        </div >
      </div >
    </Fragment >
  );
}

export default SignIn;